<template>
  <a-select
    mode="combobox"
    show-search
    allow-clear
    option-filter-prop="children"
    option-label-prop="value"
    :value="value"
    :placeholder="placeholder"
    @change="onChange">
    <a-select-option v-for="item in attributeNameOptions" :key="item.value" :value="item.value">
      {{ item.label }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'AttributeNameSelect',
  props: {
    value: {
      type: String,
    },
    attributeNameOptions: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    onChange (val) {
      this.$emit('change', val)
      this.$emit('input', val)
    },
  },
}
</script>
